import './App.less';
import ContactUs from './Model/ConatctUs';
import Footer from './Model/Footer';
import Header from './Model/Header';
import Testimonials from './Model/Testimonials';
import logo from './logo.jpeg';
import { useNavigate } from 'react-router-dom';
import ImageShow from './Model/ImageShow';
import LeftCard from './Model/leftSideBox';
import RightCard from './Model/RightSideBox';


function HomeDesign() {
  const navigate = useNavigate();
  const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems: [
      { name: 'Home', link: '/', onClick: () => navigate('/') },
      { name: 'About', link: '/aboutus', onClick: () => navigate('/aboutus') },
      {
        name: 'Gallery',
        link: '/gallery',
        children: [
          {
            name: 'Custom Built',
            link: '/gallery/custom-built',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Home Design',
            link: '/gallery/home-design',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Knockdown Rebuilt',
            link: '/gallery/knockdown-rebuilt',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Townhouses',
            link: '/gallery/townhouses',
            onClick: () => navigate('/comingsoon')
          }
        ]
      },
      { name: 'Contact', link: '/contact', onClick: () => navigate('/contact') }
    ]
  };

  const des = "Home Design For U!"
  const Brand = "Aspire Homes"
  return (
    <>
      <Header {...headerConfig} />
      <ImageShow image="/images/app/contact.png" title="Home Designs " des={des} />
      <RightCard
        image="/images/app/design.png"
        header=" Why Choose Aspire Homes for Your Design Journey"
        description={
          <>
           At Aspire Homes, we believe your home should be more than just a place to live—it should be a reflection of who you are and how you want to feel every day. Our expert design team combines creativity, functionality, and your personal style to create spaces that truly inspire.

          </>
        }
        description01={
          <>
           
              Our Design Philosophy: Human-Centered Design: Every room we design prioritizes how you actually live, work, and relax in your space.
             
          </>
        }
        description02={
          <>
             Timeless Elegance: We create interiors that feel fresh today and will remain beautiful for years to come.
          </>
        }
        description03={
          <>
          Sustainable Luxury: Beautiful design doesn't have to compromise the environment—we source responsibly and build to last.
          </>
        }
      />
       <LeftCard
        image="/images/app/HomeDesign.jpg"
        header=" Comprehensive Design Services"
        description={
          <>
           🏠 Full Home Design: Transform your entire home with our complete design service: • Space planning and layout optimization • Color schemes and material selection • Custom furniture and fixture recommendations • Lighting design and ambiance creation • Project management from concept to completion

          </>
        }
        description01={
          <>
           
          🛏️ Room-by-Room Solutions: Focus on specific spaces that matter most: • Living Spaces: Create welcoming areas for family and entertaining • Master Suites: Design restful retreats that promote relaxation • Kitchens: Blend functionality with style for the heart of your home • Home Offices: Productive workspaces that inspire creativity • Children's Rooms: Safe, fun environments that grow with your family

             
          </>
        }
        description02={
          <>
             🎨 Design Consultation: Not sure where to start? Our consultation services include: • 90-minute design assessment and vision session • Personalized style guide and color palette • Actionable recommendations you can implement yourself • Shopping lists and budget planning guidance
          </>
        }
      />
      <LeftCard
        image="/images/app/assesment.png"
        header="1: Discovery & Vision"
        description={
          <>
            We begin by understanding your lifestyle, preferences, and goals through detailed conversations and space assessments.
          </>
        }
      />

      <RightCard
        image="/images/app/design.png"
        header="2. Concept Development"
        description={
          <>
            Our team creates initial design concepts with mood boards, floor plans, and 3D visualizations to bring your vision to life.

          </>
        }
      />

      <LeftCard
        image="/images/app/stretgy.png"
        header="3.Design Refinement"
        description={
          <>
           Together, we refine every detail—from paint colors to furniture placement—ensuring the final design exceeds your expectations.
          </>
        }
      />

      <RightCard
        image="/images/app/quality.png"
        header="4. Implementation Support"
        description={
          <>
          We coordinate with contractors, manage timelines, and oversee installation to ensure flawless execution of your design.
          </>
        }
      />
      <Testimonials id="testimonials" />
      <ContactUs id="contact" />
      <Footer />
    </>
  );

};


export default HomeDesign;
